/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class ResequenceGroupsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return this.store.findAll('people-schema/group');
  }
}
